<template>
  <div class="page-shell course-detail-page" :class="layoutClass" :style="courseThemeStyle">
    <section class="container">
      <div v-if="loading" class="status-card">正在加载课程详情...</div>
      <div v-else-if="errorMessage" class="status-card is-error">
        {{ errorMessage }}
      </div>
      <template v-else-if="course.id">
        <section v-if="courseLayout === 'stage'" class="course-stage">
          <div class="course-stage__backdrop" :style="heroBackdropStyle"></div>
          <div class="course-stage__glow course-stage__glow--left"></div>
          <div class="course-stage__glow course-stage__glow--right"></div>

          <div class="course-stage__inner">
            <div class="course-stage__crumbs">
              <router-link :to="{ name: 'home' }">首页</router-link>
              <span>/</span>
              <router-link :to="{ name: 'courses' }">课程中心</router-link>
              <span>/</span>
              <strong>{{ course.title }}</strong>
            </div>

            <div class="course-stage__headline">
              <p class="eyebrow">Course Detail</p>
              <h1>{{ course.title }}</h1>
            </div>
          </div>
        </section>

        <section v-if="courseLayout === 'stage'" class="panel course-summary">
          <div class="course-summary__body">
            <div class="course-summary__main">
              <div class="course-summary__highlight">
                <span class="course-summary__tag">系统化内容</span>
                <div class="course-summary__metric">
                  <strong>{{ summaryHeroValue }}</strong>
                  <span>{{ summaryHeroLabel }}</span>
                </div>
                <p>{{ course.category_two_name || course.category_one_name || '课程专题' }} · 主讲 {{ course.lecturer_name || featuredTeacherName }}</p>
              </div>

              <div class="course-summary__meta">
                <div
                  v-for="item in summaryMetaList"
                  :key="item.label"
                  class="course-summary__meta-item"
                >
                  <span>{{ item.label }}</span>
                  <strong>{{ item.value }}</strong>
                </div>
              </div>
            </div>

            <div class="course-summary__actions">
              <button class="btn btn--primary" type="button" @click="activeTab = 'catalog'">
                查看目录
              </button>
              <button
                v-if="isAuthenticated"
                :class="['btn', enrollmentButtonClass]"
                type="button"
                :disabled="enrollmentButtonDisabled"
                @click="handleEnrollmentAction"
              >
                {{ enrollmentButtonText }}
              </button>
              <router-link v-else class="btn btn--primary" :to="loginRedirectLocation">
                登录后加入课程
              </router-link>
              <!-- <router-link

                class="btn btn--primary"
                :to="{ name: 'course-progress', params: { id: courseId } }"
              >
                学习进度
              </router-link> -->
              <router-link

                class="btn btn--secondary"
                :to="{ name: 'course-process', params: { id: courseId } }"
              >
                教学流程
              </router-link>
              <router-link
                v-if="isAuthenticated"
                class="btn btn--secondary"
                :to="{ name: 'course-enrollment', params: { id: courseId } }"
              >
                课程学员
              </router-link>
              <router-link
                class="btn btn--secondary"
                :to="{ name: 'homework-list', params: { courseId } }"
              >
                课程作业
              </router-link>
              <router-link class="btn btn--secondary" :to="{ name: 'courses' }">
                返回课程中心
              </router-link>
            </div>
          </div>
        </section>

        <section v-else-if="courseLayout === 'split'" class="course-brief">
          <div class="course-brief__copy">
            <div class="course-stage__crumbs">
              <router-link :to="{ name: 'home' }">首页</router-link>
              <span>/</span>
              <router-link :to="{ name: 'courses' }">课程中心</router-link>
              <span>/</span>
              <strong>{{ course.title }}</strong>
            </div>

            <p class="eyebrow">Course Detail</p>
            <h1>{{ course.title }}</h1>
            <p>{{ courseDescriptionSummary }}</p>

            <div class="course-brief__actions">
              <button class="btn btn--primary" type="button" @click="activeTab = 'catalog'">
                查看目录
              </button>
              <button
                v-if="isAuthenticated"
                :class="['btn', enrollmentButtonClass]"
                type="button"
                :disabled="enrollmentButtonDisabled"
                @click="handleEnrollmentAction"
              >
                {{ enrollmentButtonText }}
              </button>
              <router-link v-else class="btn btn--primary" :to="loginRedirectLocation">
                登录后加入课程
              </router-link>
              <router-link
                class="btn btn--secondary"
                :to="{ name: 'course-process', params: { id: courseId } }"
              >
                教学流程
              </router-link>
              <router-link
                v-if="isAuthenticated"
                class="btn btn--secondary"
                :to="{ name: 'course-enrollment', params: { id: courseId } }"
              >
                课程学员
              </router-link>
              <router-link
                class="btn btn--secondary"
                :to="{ name: 'homework-list', params: { courseId } }"
              >
                课程作业
              </router-link>
            </div>
          </div>

          <aside class="course-brief__media">
            <div class="course-brief__cover">
              <img v-if="courseCoverUrl" :src="courseCoverUrl" :alt="course.title">
              <span v-else>{{ teacherInitial }}</span>
            </div>
            <div class="course-brief__stats">
              <div
                v-for="item in summaryMetaList.slice(0, 4)"
                :key="item.label"
                class="course-brief__stat"
              >
                <span>{{ item.label }}</span>
                <strong>{{ item.value }}</strong>
              </div>
            </div>
          </aside>
        </section>

        <section v-else class="course-dashboard">
          <div class="course-dashboard__top">
            <div class="course-stage__crumbs">
              <router-link :to="{ name: 'home' }">首页</router-link>
              <span>/</span>
              <router-link :to="{ name: 'courses' }">课程中心</router-link>
              <span>/</span>
              <strong>{{ course.title }}</strong>
            </div>

            <div class="course-dashboard__actions">
              <router-link class="btn btn--secondary" :to="{ name: 'courses' }">
                返回课程中心
              </router-link>
              <router-link
                class="btn btn--primary"
                :to="{ name: 'course-process', params: { id: courseId } }"
              >
                教学流程
              </router-link>
              <button
                v-if="isAuthenticated"
                :class="['btn', enrollmentButtonClass]"
                type="button"
                :disabled="enrollmentButtonDisabled"
                @click="handleEnrollmentAction"
              >
                {{ enrollmentButtonText }}
              </button>
              <router-link v-else class="btn btn--primary" :to="loginRedirectLocation">
                登录后加入课程
              </router-link>
              <router-link
                v-if="isAuthenticated"
                class="btn btn--secondary"
                :to="{ name: 'course-enrollment', params: { id: courseId } }"
              >
                课程学员
              </router-link>
              <router-link
                class="btn btn--secondary"
                :to="{ name: 'homework-list', params: { courseId } }"
              >
                课程作业
              </router-link>
            </div>
          </div>

          <div class="course-dashboard__grid">
            <div class="course-dashboard__title">
              <p class="eyebrow">Course Workspace</p>
              <h1>{{ course.title }}</h1>
              <p>{{ courseDescriptionSummary }}</p>
            </div>

            <div class="course-dashboard__metric">
              <span>{{ summaryHeroLabel }}</span>
              <strong>{{ summaryHeroValue }}</strong>
            </div>

            <div class="course-dashboard__teacher">
              <div class="teacher-card__avatar-wrap">
                <img
                  v-if="featuredTeacherAvatar"
                  class="teacher-card__avatar"
                  :src="featuredTeacherAvatar"
                  :alt="featuredTeacherName"
                >
                <span v-else class="teacher-card__fallback">{{ teacherInitial }}</span>
              </div>
              <div>
                <span>主讲老师</span>
                <strong>{{ featuredTeacherName }}</strong>
                <p>{{ featuredTeacherRole }}</p>
              </div>
            </div>
          </div>

          <div class="course-dashboard__meta">
            <div
              v-for="item in summaryMetaList"
              :key="item.label"
              class="course-summary__meta-item"
            >
              <span>{{ item.label }}</span>
              <strong>{{ item.value }}</strong>
            </div>
          </div>
        </section>

        <section :class="['course-tabs', `course-tabs--${courseLayout}`]">
          <button
            v-for="tab in detailTabs"
            :key="tab.id"
            :class="['course-tab', { 'is-active': activeTab === tab.id }]"
            type="button"
            @click="activeTab = tab.id"
          >
            <span>{{ tab.label }}</span>
            <small v-if="tab.badge">{{ tab.badge }}</small>
          </button>
        </section>

        <section class="detail-content">
          <template v-if="activeTab === 'intro'">
            <section class="panel intro-spotlight">
              <aside class="intro-mentor">
                <div class="intro-mentor__portrait">
                  <img
                    v-if="featuredTeacherAvatar"
                    :src="featuredTeacherAvatar"
                    :alt="featuredTeacherName"
                  >
                  <span v-else>{{ teacherInitial }}</span>
                </div>
                <span class="intro-mentor__badge">讲师</span>
                <h2>{{ featuredTeacherName }}</h2>
                <p>{{ featuredTeacherRole }}</p>
              </aside>

              <div class="intro-story">
                <span class="intro-story__quote">“</span>
                <h3>课程介绍</h3>
                <div class="intro-story__content" v-html="courseDescriptionHtml"></div>

                <div class="chip-group">
                  <span class="pill">{{ course.category_one_name || '' }}</span>
                  <span class="pill">{{ course.category_two_name || '' }}</span>
                  <span class="pill">{{ course.serialize_status_word || '' }}</span>
                  <span class="pill">{{ totalLessonCount }} 节内容</span>
                  <span class="pill">{{ formatDuration(totalDurationSeconds) }}</span>
                </div>
              </div>
            </section>

            <section class="intro-grid">
              <article
                v-for="item in introHighlights"
                :key="item.title"
                class="panel intro-card"
              >
                <span class="intro-card__eyebrow">{{ item.eyebrow }}</span>
                <h3>{{ item.title }}</h3>
                <p>{{ item.description }}</p>
              </article>
            </section>
          </template>

          <template v-else-if="activeTab === 'catalog'">
            <section class="detail-section">
              <div class="section-heading">
                <div class="section-heading__copy">
                  <h2>章节目录</h2>
                  <p>按照课程详情接口返回的章节树结构展示章与节。</p>
                </div>
              </div>

              <div v-if="chapterList.length" class="catalog-list">
                <article
                  v-for="chapter in chapterList"
                  :key="chapter.id"
                  class="panel catalog-card"
                >
                  <div class="catalog-card__head">
                    <div class="catalog-card__title">
                      <span class="catalog-card__index">Chapter</span>
                      <h3>{{ chapter.title }}</h3>
                      <div
                        v-if="chapter.intro"
                        class="catalog-card__intro"
                        v-html="chapter.intro"
                      ></div>
                      <p v-else>暂无章节介绍</p>
                    </div>

                    <div class="chip-group">
                      <span class="pill">{{ chapterLessonCount(chapter) }} 节</span>
                      <span class="pill">{{ formatDuration(chapter.duration) }}</span>
                    </div>
                  </div>

                  <div
                    v-if="taskPointsFor(1, chapter.id).length"
                    class="task-point-list task-point-list--chapter"
                  >
                    <article
                      v-for="point in taskPointsFor(1, chapter.id)"
                      :key="point.id"
                      class="task-point-item"
                    >
                      <strong>{{ point.title }}</strong>
                      <p v-if="point.content">{{ point.content }}</p>
                    </article>
                  </div>

                  <div
                    v-if="examForTarget(1, chapter.id)"
                    class="catalog-exam"
                    @click.stop
                  >
                    <div class="catalog-exam__content">
                      <span class="catalog-exam__label">章节考试</span>
                      <strong>本章已关联考试</strong>
                      <span v-if="examForTarget(1, chapter.id).is_passed === 1" class="catalog-exam__status is-passed">已通过</span>
                      <span v-else class="catalog-exam__status">可以参加考试</span>
                    </div>
                    <button
                      v-if="examForTarget(1, chapter.id).is_passed !== 1"
                      class="btn btn--primary btn--sm"
                      type="button"
                      @click.stop="startCourseExam(examForTarget(1, chapter.id))"
                    >
                      {{ isAuthenticated ? '参加考试' : '登录后参加' }}
                    </button>
                  </div>

                  <div v-if="chapter.children && chapter.children.length" class="catalog-section-list">
                    <article
                      v-for="section in chapter.children"
                      :key="section.id"
                      class="catalog-section"
                      @click="goToSection(section)"
                    >
                      <div class="catalog-section__header">
                        <div>
                          <strong>{{ section.title }}</strong>
                          <div
                            v-if="section.intro"
                            class="catalog-section__intro"
                            v-html="section.intro"
                          ></div>
                          <p v-else>{{ `${section.level_word || '节'}内容持续补充中。` }}</p>
                        </div>
                        <span>{{ chapterSectionMeta(section) }}</span>
                      </div>
                      <div
                        v-if="examForTarget(2, section.id)"
                        class="catalog-exam catalog-exam--section"
                        @click.stop
                      >
                        <div class="catalog-exam__content">
                          <span class="catalog-exam__label">小节考试</span>
                          <strong>本节已关联考试</strong>
                          <span v-if="examForTarget(2, section.id).is_passed === 1" class="catalog-exam__status is-passed">已通过</span>
                          <span v-else class="catalog-exam__status">可以参加考试</span>
                        </div>
                        <button
                          v-if="examForTarget(2, section.id).is_passed !== 1"
                          class="btn btn--primary btn--sm"
                          type="button"
                          @click.stop="startCourseExam(examForTarget(2, section.id))"
                        >
                          {{ isAuthenticated ? '参加考试' : '登录后参加' }}
                        </button>
                      </div>
                      <div
                        v-if="taskPointsFor(1, section.id).length"
                        class="task-point-list task-point-list--section"
                        @click.stop
                      >
                        <article
                          v-for="point in taskPointsFor(1, section.id)"
                          :key="point.id"
                          class="task-point-item"
                        >
                          <strong>{{ point.title }}</strong>
                          <p v-if="point.content">{{ point.content }}</p>
                        </article>
                      </div>
                    </article>
                  </div>
                  <div v-else class="status-card is-empty">当前章节暂未配置节内容。</div>
                </article>
              </div>
              <div v-else class="status-card is-empty">当前课程暂未配置章节内容。</div>
            </section>
          </template>

          <template v-else-if="activeTab === 'service'">
            <section class="service-grid">
              <article
                v-for="item in serviceCards"
                :key="item.title"
                class="panel service-card"
              >
                <span class="service-card__index">{{ item.index }}</span>
                <h3>{{ item.title }}</h3>
              </article>
            </section>
          </template>

          <template v-else-if="activeTab === 'knowledge-graph'">
            <section class="detail-section">
              <div class="section-heading">
                <div class="section-heading__copy">
                  <h2>知识图谱</h2>
                  <p>课程知识点关系图谱</p>
                </div>
              </div>

              <div class="knowledge-graph-preview">
                <div class="knowledge-graph-preview__content">
                  <p>查看完整的课程知识图谱，了解知识点之间的关系和学习路径。</p>
                  <router-link
                    class="btn btn--primary"
                    :to="{ name: 'knowledge-graph', params: { courseId: courseId } }"
                  >
                    查看知识图谱
                  </router-link>
                </div>
              </div>
            </section>
          </template>

          <template v-else-if="activeTab === 'resources'">
            <section class="detail-section">
              <div class="section-heading">
                <div class="section-heading__copy">
                  <h2>推荐资源</h2>
                  <p>课程相关的学习资源推荐</p>
                </div>
              </div>

              <div v-if="loadingResources" class="status-card">正在加载资源...</div>
              <div v-else-if="resourceList.length" class="resource-grid">
                <article
                  v-for="resource in resourceList"
                  :key="resource.id"
                  class="panel resource-card"
                  @click="viewResourceDetail(resource)"
                >
                  <div class="resource-card__icon">
                    <span>{{ getResourceIcon(resource.type) }}</span>
                  </div>
                  <div class="resource-card__content">
                    <h3>{{ resource.title }}</h3>
                    <p>{{ resource.description || '暂无描述' }}</p>
                    <div class="resource-card__meta">
                      <span class="pill">{{ resource.type_word || '资源' }}</span>
                      <span v-if="resource.author" class="pill">{{ resource.author }}</span>
                    </div>
                    <button
                      v-if="isAuthenticated"
                      class="resource-card__share"
                      type="button"
                      @click.stop="goForwardResourceToGroup(resource)"
                    >
                      转发到学习小组
                    </button>
                  </div>
                </article>
              </div>
              <div v-else class="status-card is-empty">当前课程暂未配置推荐资源。</div>
            </section>
          </template>

          <template v-else-if="activeTab === 'textbooks'">
            <section class="detail-section">
              <div class="section-heading">
                <div class="section-heading__copy">
                  <h2>电子教材</h2>
                  <p>课程配套的电子教材</p>
                </div>
              </div>

              <div v-if="loadingTextbooks" class="status-card">正在加载教材...</div>
              <div v-else-if="textbookList.length" class="textbook-grid">
                <article
                  v-for="textbook in textbookList"
                  :key="textbook.id"
                  class="panel textbook-card"
                >
                  <div class="textbook-card__cover">
                    <img
                      v-if="resolveAssetUrl(textbook.cover_url || textbook.cover)"
                      :src="resolveAssetUrl(textbook.cover_url || textbook.cover)"
                      :alt="textbook.title"
                    >
                    <span v-else class="textbook-card__fallback">📖</span>
                  </div>
                  <div class="textbook-card__content">
                    <h3>{{ textbook.title }}</h3>
                    <p v-if="textbook.file_name">文件名：{{ textbook.file_name }}</p>
                    <p v-if="textbook.read_mode_word">阅读模式：{{ textbook.read_mode_word }}</p>
                    <div class="textbook-card__meta">
                      <span v-if="textbook.total_pages" class="pill">{{ textbook.total_pages }} 页</span>
                      <span class="pill">{{ textbook.file_type || 'PDF' }}</span>
                      <span v-if="textbook.task_point_word" class="pill">{{ textbook.task_point_word }}</span>
                    </div>
                  </div>
                  <div class="textbook-card__actions">
                    <button
                      class="textbook-action textbook-action--preview"
                      type="button"
                      @click="previewTextbook(textbook)"
                    >
                      预览
                    </button>
                    <button
                      class="textbook-action textbook-action--read"
                      type="button"
                      @click="readTextbook(textbook)"
                    >
                      阅读
                    </button>
                  </div>
                </article>
              </div>
              <div v-else class="status-card is-empty">当前课程暂未配置电子教材。</div>
            </section>
          </template>

          <template v-else-if="activeTab === 'teachers'">
            <section class="detail-section">
              <div class="section-heading">
                <div class="section-heading__copy">
                  <h2>讲师阵容</h2>
                </div>
              </div>

              <div v-if="teacherList.length" class="teacher-grid">
                <article
                  v-for="teacher in teacherList"
                  :key="`${teacher.id}-${teacher.teacher_uid}`"
                  class="panel teacher-card"
                >
                  <div class="teacher-card__avatar-wrap">
                    <img
                      v-if="resolveAssetUrl(teacher.teacher_avatar)"
                      class="teacher-card__avatar"
                      :src="resolveAssetUrl(teacher.teacher_avatar)"
                      :alt="teacherDisplayName(teacher)"
                    >
                    <span v-else class="teacher-card__fallback">{{ teacherInitialOf(teacher) }}</span>
                  </div>

                  <div class="teacher-card__content">
                    <h3>{{ teacherDisplayName(teacher) }}</h3>
                    <p>{{ teacher.role_type_word || '课程教师' }}</p>
                    <span>{{ teacher.teacher_name || '未设置账号名' }}</span>
                  </div>
                </article>
              </div>
              <div v-else class="status-card is-empty">当前课程暂未关联教师信息。</div>
            </section>
          </template>
        </section>

        <div
          v-if="resourceDetailVisible"
          class="resource-detail-dialog"
          @click.self="closeResourceDetail"
        >
          <section class="resource-detail-dialog__panel panel">
            <button
              class="resource-detail-dialog__close"
              type="button"
              aria-label="关闭资源详情"
              @click="closeResourceDetail"
            >
              ×
            </button>

            <div v-if="loadingResourceDetail" class="status-card">正在加载资源详情...</div>
            <div v-else-if="resourceDetailError" class="status-card is-error">{{ resourceDetailError }}</div>
            <template v-else-if="resourceDetail.id">
              <div class="resource-detail-dialog__header">
                <div class="resource-detail-dialog__icon">{{ getResourceIcon(resourceDetail.type) }}</div>
                <div class="resource-detail-dialog__heading">
                  <span class="pill">{{ resourceDetail.type_word || '资源' }}</span>
                  <h3>{{ resourceDetail.title }}</h3>
                  <p>{{ resourceDetail.author || '未填写作者/出版方' }}</p>
                </div>
              </div>

              <div class="resource-detail-dialog__body">
                <p v-if="resourceDetail.description">{{ resourceDetail.description }}</p>
                <p v-else>当前资源暂未配置详细描述。</p>

                <div class="resource-detail-dialog__meta">
                  <span v-if="resourceDetail.isbn" class="pill">ISBN {{ resourceDetail.isbn }}</span>
                  <span v-if="resourceDetail.published_year" class="pill">{{ resourceDetail.published_year }} 年</span>
                </div>
              </div>

              <div class="resource-detail-dialog__actions">
                <button
                  v-if="resourceDetail.file_url"
                  class="btn btn--primary"
                  type="button"
                  @click="openResourceFile(resourceDetail)"
                >
                  在线查看
                </button>
                <button
                  class="btn btn--secondary"
                  type="button"
                  :disabled="resourceShare.loading"
                  @click="forwardResourceToNote"
                >
                  转为笔记
                </button>
                <button
                  class="btn btn--secondary"
                  type="button"
                  :disabled="resourceShare.loading"
                  @click="goForwardResourceToGroup(resourceDetail)"
                >
                  转发到学习小组
                </button>
                <button
                  class="btn btn--secondary"
                  type="button"
                  :disabled="resourceShare.loading"
                  @click="createResourceShare"
                >
                  生成分享链接
                </button>
                <router-link class="btn btn--secondary" :to="{ name: 'notifications' }">
                  系统通知
                </router-link>
                <button class="btn btn--secondary" type="button" @click="closeResourceDetail">
                  关闭
                </button>
              </div>

              <div v-if="resourceShare.error" class="status-card is-error">{{ resourceShare.error }}</div>
              <div v-if="resourceShare.message" class="status-card">{{ resourceShare.message }}</div>
              <div v-if="resourceShare.info.id || resourceShare.link.share_url" class="resource-share-box">
                <template v-if="resourceShare.link.share_url">
                  <span>分享链接</span>
                  <a :href="resourceShare.link.share_url" target="_blank" rel="noopener noreferrer">
                    {{ resourceShare.link.share_url }}
                  </a>
                  <img v-if="resourceShare.link.qrcode" :src="resourceShare.link.qrcode" alt="资源分享二维码">
                </template>
                <template v-if="resourceShare.info.id">
                  <span>公开分享预览</span>
                  <strong>{{ resourceShare.info.title }}</strong>
                  <p>{{ resourceShare.info.description || '暂无简介' }}</p>
                </template>
              </div>
            </template>
          </section>
        </div>
      </template>
    </section>
  </div>
</template>

<script>
import { fetchCourseDetail, fetchCourseEnrollmentStatus, joinCourse, leaveCourse } from '@/api/course'
import { fetchStudentSettings, hasStudentNavigation } from '@/api/student-settings'
import { reportLearningActivity, ACTIVITY_MATERIAL_READ, ACTIVITY_PAGE_VIEW } from '@/api/learningActivity'
import {
  createMaterialShareLink,
  fetchCourseResourceList,
  fetchMaterialShareInfo,
  fetchResourceDetail,
  forwardMaterial
} from '@/api/courseResource'
import { fetchChapterTextbookList, fetchTextbookPreviewConfig } from '@/api/courseTextbook'
import { fetchCourseTaskPoints } from '@/api/courseTaskPoint'
import { fetchCourseProcessTree } from '@/api/courseProcess'
import { sessionState } from '@/store/session'
import { formatDuration, resolveAssetUrl } from '@/utils/format'
import { getCourseThemeStyle } from '@/utils/courseTheme'
import { isPptFile, openPptPreviewInNewPage } from '@/utils/pptPreview'

export default {
  name: 'CourseDetailView',
  props: {
    courseId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: true,
      errorMessage: '',
      course: {},
      activeTab: 'intro',
      resourceList: [],
      loadingResources: false,
      resourceDetailVisible: false,
      resourceDetail: {},
      loadingResourceDetail: false,
      resourceDetailError: '',
      resourceShare: {
        loading: false,
        error: '',
        message: '',
        link: {},
        info: {}
      },
      textbookList: [],
      loadingTextbooks: false,
      taskPointMap: {},
      processExamMap: {},
      studentSettings: null,
      enrollmentStatus: {
        enrollment_id: 0,
        course_id: 0,
        joined: 0,
        changed: 0,
        joined_at: null,
        left_at: null
      },
      enrollmentStatusLoading: false,
      enrollmentActionLoading: false,
      pageVisitReported: false
    }
  },
  computed: {
    isAuthenticated() {
      return Boolean(sessionState.token)
    },
    isCourseJoined() {
      return Number(this.enrollmentStatus && this.enrollmentStatus.joined) === 1
    },
    enrollmentButtonClass() {
      return this.isCourseJoined ? 'btn--secondary' : 'btn--primary'
    },
    enrollmentButtonDisabled() {
      return this.enrollmentStatusLoading || this.enrollmentActionLoading
    },
    enrollmentButtonText() {
      if (this.enrollmentStatusLoading) {
        return '查询状态...'
      }

      if (this.enrollmentActionLoading) {
        return this.isCourseJoined ? '退出中...' : '加入中...'
      }

      return this.isCourseJoined ? '退出课程' : '加入课程'
    },
    loginRedirectLocation() {
      return {
        name: 'login',
        query: {
          redirect: this.$route.fullPath
        }
      }
    },
    monitoringEnabled() {
      return Boolean(this.studentSettings && this.studentSettings.monitoring && this.studentSettings.monitoring.enabled)
    },
    teacherList() {
      return Array.isArray(this.course.teacher_list) ? this.course.teacher_list : []
    },
    chapterList() {
      return Array.isArray(this.course.chapter_list) ? this.course.chapter_list : []
    },
    courseDescriptionHtml() {
      const description = String(this.course.description || '').trim()

      return description || '<p>当前课程还没有补充详细介绍。</p>'
    },
    courseDescriptionSummary() {
      const plainText = this.stripHtml(this.course.description)

      return plainText || '当前课程还没有补充详细介绍。'
    },
    courseThemeStyle() {
      return getCourseThemeStyle(this.course)
    },
    courseLayout() {
      const layoutValue = this.resolveCourseLayoutValue()

      if (['2', 'split', 'b'].includes(layoutValue)) {
        return 'split'
      }

      if (['3', 'dashboard', 'c'].includes(layoutValue)) {
        return 'dashboard'
      }

      return 'stage'
    },
    layoutClass() {
      return `course-detail-page--${this.courseLayout}`
    },
    courseCoverUrl() {
      return resolveAssetUrl(this.course.cover)
    },
    featuredTeacher() {
      if (this.teacherList.length) {
        return this.teacherList[0]
      }

      return {
        teacher_display_name: this.course.lecturer_name || '课程讲师',
        teacher_realname: this.course.lecturer_name || '课程讲师',
        role_type_word: '主讲老师',
        teacher_avatar: ''
      }
    },
    featuredTeacherName() {
      return this.teacherDisplayName(this.featuredTeacher)
    },
    featuredTeacherRole() {
      return this.featuredTeacher.role_type_word || '课程讲师'
    },
    featuredTeacherAvatar() {
      return resolveAssetUrl(this.featuredTeacher.teacher_avatar)
    },
    teacherInitial() {
      return this.teacherInitialOf(this.featuredTeacher)
    },
    totalLessonCount() {
      return this.chapterList.reduce((total, chapter) => total + this.chapterLessonCount(chapter), 0)
    },
    totalDurationSeconds() {
      return this.chapterList.reduce((total, chapter) => total + (Number(chapter.duration) || 0), 0)
    },
    summaryHeroValue() {
      if (this.totalLessonCount > 0) {
        return this.totalLessonCount
      }

      return this.chapterList.length || 0
    },
    summaryHeroLabel() {
      return this.totalLessonCount > 0 ? '节核心内容' : '章课程结构'
    },
    summaryMetaList() {
      return [
        { label: '课程状态', value: this.course.serialize_status_word || '更新中' },
        { label: '课程方向', value: this.course.category_two_name || this.course.category_one_name || '未分类' },
        { label: '总时长', value: this.formatCourseDuration(this.totalDurationSeconds) },
        { label: '章节数量', value: `${this.chapterList.length} 章` },
        { label: '讲师人数', value: `${this.course.teacher_count || this.teacherList.length || 1} 位` }
      ]
    },
    detailTabs() {
      const tabs = [
        { id: 'intro', label: '课程介绍' },
        { id: 'catalog', label: '章节目录', badge: this.totalLessonCount > 0 ? `${this.totalLessonCount}` : `${this.chapterList.length}` },
        { id: 'knowledge-graph', label: '知识图谱' },
        { id: 'resources', label: '课内资源', badge: this.resourceList.length ? `${this.resourceList.length}` : '' },
        { id: 'textbooks', label: '电子教材', badge: this.textbookList.length ? `${this.textbookList.length}` : '' },
        { id: 'service', label: '学习服务' },
        { id: 'teachers', label: '讲师阵容', badge: this.teacherList.length ? `${this.teacherList.length}` : '' }
      ]

      return tabs.filter(tab => tab.id !== 'resources' || hasStudentNavigation(this.studentSettings, ['resources']))
    },
    introHighlights() {
      return [
        {
          eyebrow: 'Track',
          title: this.course.category_two_name || this.course.category_one_name || '课程方向',
          description: '围绕当前课程方向组织章节内容，方便从路径上快速定位学习重点。'
        },
        {
          eyebrow: 'Duration',
          title: this.formatCourseDuration(this.totalDurationSeconds),
          description: `目前共整理 ${this.chapterList.length} 章、${this.totalLessonCount} 节内容，适合系统化推进学习节奏。`
        },
        {
          eyebrow: 'Team',
          title: `${this.course.teacher_count || this.teacherList.length || 1} 位讲师协同`,
          description: `主讲 ${this.course.lecturer_name || this.featuredTeacherName}，同时结合课程教师阵容持续完善内容。`
        }
      ]
    },
    serviceCards() {
      return [
        {
          index: '01',
          title: '结构化目录',
          description: `章节树已整理为 ${this.chapterList.length} 个章节，便于按模块推进学习。`
        },
        {
          index: '02',
          title: '持续更新',
          description: `课程当前状态为“${this.course.serialize_status_word || '更新中'}”，后续内容会继续补充。`
        },
        {
          index: '03',
          title: '多讲师协作',
          description: `当前已接入 ${this.course.teacher_count || this.teacherList.length || 1} 位讲师信息，适合形成完整知识视角。`
        },
        {
          index: '04',
          title: '会员学习链路',
          description: '站点已接通会员登录与个人中心，可作为后续学习记录与课程浏览入口。'
        }
      ]
    },
    heroBackdropStyle() {
      const cover = this.courseCoverUrl

      if (!cover) {
        return {}
      }

      return {
        backgroundImage: `linear-gradient(135deg, rgba(107, 17, 63, 0.82) 0%, rgba(221, 28, 118, 0.78) 100%), url(${cover})`
      }
    }
  },
  created() {
    this.loadCourseDetail()
    this.loadStudentSettings()
  },
  methods: {
    async loadStudentSettings() {
      try {
        this.studentSettings = await fetchStudentSettings(0)
        if (this.activeTab === 'resources' && !hasStudentNavigation(this.studentSettings, ['resources'])) {
          this.activeTab = 'intro'
        }
        this.tryReportPageVisit()
      } catch (error) {
        console.error('加载学生端配置失败', error)
      }
    },
    tryReportPageVisit() {
      if (this.pageVisitReported || !this.isAuthenticated || !this.monitoringEnabled || !this.course.id) return
      this.pageVisitReported = true
      reportLearningActivity({
        activity_type: ACTIVITY_PAGE_VIEW,
        course_id: this.courseId,
        resource_type: 'course',
        resource_id: this.courseId,
        resource_title: this.course.title || '',
        page_route: this.$route.path,
        page_title: '课程详情',
        page_params: this.$route.query
      }).catch(error => console.error('上报页面访问日志失败', error))
    },
    reportResourceRead(resource = {}) {
      if (!this.isAuthenticated || !this.monitoringEnabled || !resource.id) return
      reportLearningActivity({
        activity_type: ACTIVITY_MATERIAL_READ,
        course_id: this.courseId,
        chapter_id: Number(resource.chapter_id) || 0,
        resource_type: 'resource',
        resource_id: resource.id,
        resource_title: resource.title || '',
        page_route: this.$route.path,
        page_title: '课程资源'
      }).catch(error => console.error('上报资料阅读日志失败', error))
    },
    formatDuration,
    resolveAssetUrl,
    stripHtml(content) {
      return String(content || '')
        .replace(/<[^>]+>/g, ' ')
        .replace(/&nbsp;/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
    },
    teacherDisplayName(teacher = {}) {
      return teacher.teacher_display_name || teacher.teacher_realname || teacher.teacher_name || '课程讲师'
    },
    teacherInitialOf(teacher = {}) {
      const name = this.teacherDisplayName(teacher)
      return String(name || '课').slice(0, 1)
    },
    chapterLessonCount(chapter = {}) {
      const count = Number(chapter.lesson_count)
      if (count > 0) {
        return count
      }

      return Array.isArray(chapter.children) ? chapter.children.length : 0
    },
    chapterSectionMeta(section = {}) {
      const duration = Number(section.duration) || 0
      if (duration > 0) {
        return this.formatCourseDuration(duration)
      }

      return section.level_word || '节'
    },
    formatCourseDuration(seconds) {
      const totalSeconds = Number(seconds) || 0

      if (totalSeconds <= 0) {
        return '内容持续更新'
      }

      if (totalSeconds >= 3600) {
        return `${(totalSeconds / 3600).toFixed(totalSeconds % 3600 === 0 ? 0 : 1)} 小时`
      }

      return formatDuration(totalSeconds)
    },
    resolveCourseLayoutValue() {
      const queryValue = this.$route.query.style || this.$route.query.layout
      if (queryValue !== undefined && queryValue !== null && queryValue !== '') {
        return String(queryValue).toLowerCase()
      }

      return String(this.course.template || 1).toLowerCase()
    },
    normalizeEnrollmentStatus(payload = {}) {
      return {
        enrollment_id: Number(payload.enrollment_id) || 0,
        course_id: Number(payload.course_id) || Number(this.courseId) || 0,
        joined: Number(payload.joined) === 1 ? 1 : 0,
        changed: Number(payload.changed) || 0,
        joined_at: payload.joined_at || null,
        left_at: payload.left_at || null
      }
    },
    resetEnrollmentStatus() {
      this.enrollmentStatus = this.normalizeEnrollmentStatus()
    },
    async loadEnrollmentStatus() {
      if (!this.courseId || !this.isAuthenticated) {
        this.resetEnrollmentStatus()
        return
      }

      this.enrollmentStatusLoading = true

      try {
        this.enrollmentStatus = this.normalizeEnrollmentStatus(
          await fetchCourseEnrollmentStatus(this.courseId)
        )
      } catch (error) {
        console.error('查询课程加入状态失败:', error)
      } finally {
        this.enrollmentStatusLoading = false
      }
    },
    async handleEnrollmentAction() {
      if (this.enrollmentButtonDisabled) {
        return
      }

      if (!this.isAuthenticated) {
        this.$router.push(this.loginRedirectLocation)
        return
      }

      const shouldJoin = !this.isCourseJoined
      if (!shouldJoin && !window.confirm('确定要退出这门课程吗？退出后可以重新加入。')) {
        return
      }

      this.enrollmentActionLoading = true

      try {
        const result = shouldJoin
          ? await joinCourse(this.courseId)
          : await leaveCourse(this.courseId)
        this.enrollmentStatus = this.normalizeEnrollmentStatus(result)
      } catch (error) {
        window.alert(error.message || (shouldJoin ? '加入课程失败' : '退出课程失败'))
      } finally {
        this.enrollmentActionLoading = false
      }
    },
    goToSection(section) {
      this.navigateToSection(section)
    },
    navigateToSection(section) {
      // chapter_id
      this.$router.push({
        name: 'video-player',
        params: { kejie: section.id, course_id: section.course_id, chapter_id: section.parent_id }
      })
    },
    async loadCourseDetail() {
      if (!this.courseId) {
        this.errorMessage = '缺少有效的课程 ID。'
        this.loading = false
        return
      }

      this.loading = true
      this.errorMessage = ''

      try {
        this.course = await fetchCourseDetail(this.courseId)
        this.tryReportPageVisit()
        this.loadEnrollmentStatus()
        this.loadTaskPoints()
        this.loadProcessTree()
      } catch (error) {
        this.errorMessage = error.message || '课程详情加载失败'
      } finally {
        this.loading = false
      }
    },

    async loadTaskPoints() {
      const targets = this.collectChapterTargets()
      if (!targets.length) {
        this.taskPointMap = {}
        return
      }

      const results = await Promise.allSettled(
        targets.map((target) => fetchCourseTaskPoints({
          course_id: this.courseId,
          target_type: target.targetType,
          target_id: target.targetId
        }).then((points) => ({
          key: this.taskPointKey(target.targetType, target.targetId),
          points
        })))
      )

      const nextMap = {}
      results.forEach((result) => {
        if (result.status !== 'fulfilled') {
          return
        }
        nextMap[result.value.key] = result.value.points
      })
      this.taskPointMap = nextMap
    },

    collectChapterTargets() {
      const targets = []
      this.chapterList.forEach((chapter) => {
        const chapterId = Number(chapter.id || 0)
        if (chapterId > 0) {
          targets.push({ targetType: 1, targetId: chapterId })
        }

        ;(chapter.children || []).forEach((section) => {
          const sectionId = Number(section.id || 0)
          if (sectionId > 0) {
            targets.push({ targetType: 1, targetId: sectionId })
          }
        })
      })
      return targets
    },

    taskPointKey(targetType, targetId) {
      return `${Number(targetType)}-${Number(targetId)}`
    },

    taskPointsFor(targetType, targetId) {
      return this.taskPointMap[this.taskPointKey(targetType, targetId)] || []
    },

    examForTarget(targetType, targetId) {
      return this.processExamMap[this.taskPointKey(targetType, targetId)] || null
    },

    async loadProcessTree() {
      if (!this.courseId) {
        this.processExamMap = {}
        return
      }

      try {
        const processData = await fetchCourseProcessTree(this.courseId)
        const nextMap = {}
        ;(processData.chapter_list || []).forEach((chapter) => {
          if (chapter.exam) {
            nextMap[`1-${chapter.id}`] = chapter.exam
          }
          ;(chapter.children || []).forEach((section) => {
            if (section.exam) {
              nextMap[`2-${section.id}`] = section.exam
            }
          })
        })
        this.processExamMap = nextMap
      } catch (error) {
        console.error('加载课程考试配置失败:', error)
        this.processExamMap = {}
      }
    },

    startCourseExam(exam = {}) {
      const processExamId = Number(exam.process_exam_id) || 0
      if (!processExamId) {
        return
      }

      if (!this.isAuthenticated) {
        this.$router.push(this.loginRedirectLocation)
        return
      }

      this.$router.push({
        name: 'exam',
        params: { processExamId }
      })
    },

    async loadResources() {
      if (!this.courseId) return

      try {
        this.loadingResources = true
        this.resourceList = await fetchCourseResourceList(this.courseId)
      } catch (error) {
        console.error('加载资源失败:', error)
      } finally {
        this.loadingResources = false
      }
    },

    async loadTextbooks() {
      if (!this.courseId) return

      try {
        this.loadingTextbooks = true
        const chapterIds = this.chapterList
          .flatMap((chapter) => (Array.isArray(chapter.children) ? chapter.children : []))
          .map((section) => Number(section.id) || 0)
          .filter((id) => id > 0)

        if (chapterIds.length === 0) {
          this.textbookList = []
          return
        }

        const results = await Promise.allSettled(
          chapterIds.map((chapterId) => fetchChapterTextbookList(this.courseId, chapterId))
        )

        const textbookMap = new Map()
        results.forEach((result) => {
          if (result.status !== 'fulfilled') {
            return
          }

          result.value.forEach((textbook) => {
            if (!textbookMap.has(textbook.id)) {
              textbookMap.set(textbook.id, textbook)
            }
          })
        })

        this.textbookList = Array.from(textbookMap.values())
      } catch (error) {
        console.error('加载教材失败:', error)
      } finally {
        this.loadingTextbooks = false
      }
    },

    getResourceIcon(type) {
      const icons = {
        1: '📚',
        2: '📰',
        3: '📄',
        4: '🎬'
      }
      return icons[Number(type)] || '📁'
    },

    openResourceFile(resource) {
      const fileUrl = typeof resource === 'string' ? resource : resource.file_url
      if (isPptFile(resource)) {
        openPptPreviewInNewPage(this.$router, {
          file: resource,
          fileId: Number(resource.file_id) || 0,
          url: fileUrl,
          title: typeof resource === 'string' ? '' : resource.title
        })
        return
      }

      if (fileUrl) {
        window.open(fileUrl, '_blank', 'noopener')
      }
    },
    resetResourceShare() {
      this.resourceShare = {
        loading: false,
        error: '',
        message: '',
        link: {},
        info: {}
      }
    },
    async viewResourceDetail(resource) {
      const resourceType = Number(resource.type)

      if (resourceType === 4 && resource.file_url) {
        this.reportResourceRead(resource)
        this.openResourceFile(resource)
        return
      }

      this.resourceDetailVisible = true
      this.loadingResourceDetail = true
      this.resourceDetailError = ''
      this.resourceDetail = {}
      this.resetResourceShare()

      try {
        this.resourceDetail = await fetchResourceDetail(resource.id)
        this.reportResourceRead(this.resourceDetail)
      } catch (error) {
        this.resourceDetailError = error.message || '资源详情加载失败'
      } finally {
        this.loadingResourceDetail = false
      }
    },
    closeResourceDetail() {
      this.resourceDetailVisible = false
      this.resourceDetail = {}
      this.resourceDetailError = ''
      this.resetResourceShare()
    },

    async forwardResourceToNote() {
      if (!this.resourceDetail.id || this.resourceShare.loading) {
        return
      }

      this.resourceShare.loading = true
      this.resourceShare.error = ''
      this.resourceShare.message = ''

      try {
        const result = await forwardMaterial({
          resource_id: this.resourceDetail.id,
          channel: 1,
          remark: this.resourceDetail.description || ''
        })
        this.resourceShare.message = result.target_note_id
          ? `已转为个人笔记，笔记 ID：${result.target_note_id}`
          : '已完成资料转发'
      } catch (error) {
        this.resourceShare.error = error.message || '资料转发失败'
      } finally {
        this.resourceShare.loading = false
      }
    },

    goForwardResourceToGroup(resource = {}) {
      const resourceId = Number(resource.id || resource.resource_id) || 0
      if (!resourceId) return

      this.$router.push({
        name: 'study-groups',
        query: {
          shareResourceId: String(resourceId),
          shareTitle: resource.title || resource.name || ''
        }
      }).catch(() => {})
    },

    async createResourceShare() {
      if (!this.resourceDetail.id || this.resourceShare.loading) {
        return
      }

      this.resourceShare.loading = true
      this.resourceShare.error = ''
      this.resourceShare.message = ''

      try {
        const link = await createMaterialShareLink({
          resource_id: this.resourceDetail.id
        })
        this.resourceShare.link = link
        this.resourceShare.message = '分享链接已生成'

        if (link.share_token) {
          this.resourceShare.info = await fetchMaterialShareInfo(link.share_token)
        }
      } catch (error) {
        this.resourceShare.error = error.message || '分享链接生成失败'
      } finally {
        this.resourceShare.loading = false
      }
    },

    async previewTextbook(textbook) {
      if (isPptFile(textbook)) {
        let fileId = Number(textbook.file_id || textbook.resource_id) || 0
        if (!fileId) {
          try {
            const previewConfig = await fetchTextbookPreviewConfig(textbook.id)
            fileId = Number(previewConfig.file_id) || 0
          } catch (error) {
            console.error('加载 PPT 资源信息失败:', error)
          }
        }

        openPptPreviewInNewPage(this.$router, {
          file: textbook,
          fileId,
          textbookId: textbook.id,
          title: textbook.title,
          fileType: textbook.file_type
        })
        return
      }

      this.$router.push({
        name: 'textbook',
        params: { id: textbook.id },
        query: { course_id: this.courseId }
      })
    },

    readTextbook(textbook) {
      this.$router.push({
        name: 'textbook-smart-reader',
        params: { id: textbook.id },
        query: { course_id: this.courseId }
      })
    }
  },
  watch: {
    courseId() {
      this.activeTab = 'intro'
      this.studentSettings = null
      this.pageVisitReported = false
      this.resetEnrollmentStatus()
      this.resourceList = []
      this.resourceDetailVisible = false
      this.resourceDetail = {}
      this.resourceDetailError = ''
      this.textbookList = []
      this.loadCourseDetail()
      this.loadStudentSettings()
    },
    isAuthenticated(authenticated) {
      if (authenticated) {
        this.loadEnrollmentStatus()
        return
      }

      this.resetEnrollmentStatus()
    },
    activeTab(newTab) {
      if (newTab === 'resources' && this.resourceList.length === 0 && !this.loadingResources) {
        this.loadResources()
      }
      if (newTab === 'textbooks' && !this.loadingTextbooks) {
        this.loadTextbooks()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.course-detail-page {
  display: grid;
  gap: 24px;
}

.course-detail-page--split {
  background:
    linear-gradient(90deg, rgba($color-surface, 0.92) 0%, rgba($color-background, 0.78) 48%, rgba($color-primary-light, 0.58) 100%);
}

.course-detail-page--dashboard {
  background:
    linear-gradient(180deg, rgba($color-background, 0.7) 0%, rgba($color-surface, 0.86) 100%);
}

.course-stage {
  position: relative;
  overflow: hidden;
  min-height: 430px;
  padding: 34px 36px 140px;
  border-radius: 36px;
  background:
    radial-gradient(circle at 18% 88%, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0) 34%),
    radial-gradient(circle at 78% 18%, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 26%),
    linear-gradient(135deg, var(--course-theme-deep) 0%, var(--course-theme-primary) 58%, var(--course-theme-secondary) 100%);
  box-shadow: 0 30px 70px rgba(41, 31, 54, 0.18);
}

.course-stage__backdrop {
  position: absolute;
  inset: 0;
  background-position: center;
  background-size: cover;
  mix-blend-mode: soft-light;
  opacity: 0.86;
}

.course-stage__glow {
  position: absolute;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.04);
}

.course-stage__glow--left {
  bottom: -180px;
  left: -140px;
  width: 520px;
  height: 520px;
}

.course-stage__glow--right {
  top: 52px;
  right: -110px;
  width: 420px;
  height: 420px;
}

.course-stage__inner {
  position: relative;
  z-index: 1;
  display: grid;
  gap: 64px;
}

.course-stage__crumbs {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  color: rgba(255, 255, 255, 0.74);
  font-size: 14px;
}

.course-stage__crumbs strong {
  color: $color-surface;
}

.course-detail-page--split .course-stage__crumbs,
.course-detail-page--dashboard .course-stage__crumbs {
  color: $color-text-secondary;
}

.course-detail-page--split .course-stage__crumbs strong,
.course-detail-page--dashboard .course-stage__crumbs strong {
  color: $color-text-primary;
}

.course-stage__headline {
  display: grid;
  justify-items: center;
  gap: 20px;
  text-align: center;
}

.course-stage__headline .eyebrow {
  color: rgba(255, 255, 255, 0.72);
}

.course-stage__headline h1 {
  max-width: 920px;
  color: $color-surface;
  font-size: clamp(34px, 4.6vw, 68px);
  line-height: 1.08;
}

.course-stage__headline p {
  max-width: 860px;
  color: rgba(255, 255, 255, 0.86);
  font-size: clamp(16px, 2vw, 22px);
  line-height: 1.8;
}

.course-summary {
  position: relative;
  z-index: 2;
  margin: -92px auto 0;
  padding: 22px;
  border-radius: 32px;
  background:
    radial-gradient(circle at 48% 12%, rgba($color-background, 0.92) 0%, rgba($color-background, 0.18) 18%, rgba($color-background, 0) 19%),
    radial-gradient(circle at 86% 92%, rgba($color-background, 0.88) 0%, rgba($color-background, 0.1) 22%, rgba($color-background, 0) 23%),
    linear-gradient(135deg, rgba($color-surface, 0.98) 0%, rgba($color-background, 0.82) 100%);
  box-shadow: 0 26px 64px rgba(51, 51, 51, 0.12);
}

.course-summary__body {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 28px;
  align-items: center;
}

.course-summary__main {
  display: grid;
  gap: 22px;
}

.course-summary__highlight {
  display: grid;
  gap: 12px;
}

.course-summary__tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  min-height: 48px;
  padding: 0 20px;
  border-radius: 999px;
  background: linear-gradient(135deg, var(--course-theme-primary) 0%, var(--course-theme-accent) 100%);
  color: $color-surface;
  font-size: 18px;
  font-weight: 800;
}

.course-summary__metric {
  display: flex;
  align-items: baseline;
  gap: 12px;
}

.course-summary__metric strong {
  color: var(--course-theme-primary);
  font-size: clamp(44px, 5vw, 72px);
  line-height: 1;
}

.course-summary__metric span {
  color: $color-text-secondary;
  font-size: 24px;
  font-weight: 700;
}

.course-summary__highlight p {
  color: $color-text-secondary;
  font-size: 16px;
}

.course-summary__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 24px;
}

.course-summary__meta-item {
  display: inline-flex;
  align-items: baseline;
  gap: 8px;
  color: $color-text-secondary;
}

.course-summary__meta-item span {
  font-size: 14px;
}

.course-summary__meta-item strong {
  color: $color-text-primary;
  font-size: 18px;
}

.course-summary__actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 12px;
}

.course-brief {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(360px, 430px);
  gap: 42px;
  align-items: stretch;
  padding: 42px;
  border: 1px solid rgba($color-border, 0.86);
  border-radius: 28px;
  background: rgba($color-surface, 0.92);
  box-shadow: 0 24px 58px rgba(25, 31, 45, 0.09);
}

.course-brief__copy {
  display: grid;
  align-content: center;
  gap: 22px;
}

.course-brief__copy h1 {
  max-width: 760px;
  font-size: clamp(34px, 5vw, 60px);
  line-height: 1.08;
}

.course-brief__copy > p:not(.eyebrow) {
  display: -webkit-box;
  max-width: 760px;
  overflow: hidden;
  color: $color-text-secondary;
  font-size: 17px;
  line-height: 1.9;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

.course-brief__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.course-brief__media {
  display: grid;
  grid-template-rows: minmax(260px, 1fr) auto;
  gap: 18px;
  min-width: 0;
}

.course-brief__cover {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 280px;
  overflow: hidden;
  border-radius: 22px;
  background:
    radial-gradient(circle at 18% 22%, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 32%),
    linear-gradient(135deg, var(--course-theme-primary) 0%, var(--course-theme-secondary) 100%);
  color: $color-surface;
  font-size: 64px;
  font-weight: 900;
}

.course-brief__cover img {
  width: 100%;
  height: 100%;
  min-height: 280px;
  object-fit: cover;
}

.course-brief__stats {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.course-brief__stat {
  display: grid;
  gap: 4px;
  min-height: 84px;
  padding: 14px;
  border: 1px solid rgba($color-border, 0.92);
  border-radius: 16px;
  background: $color-surface;
}

.course-brief__stat span {
  color: $color-text-tertiary;
  font-size: 13px;
}

.course-brief__stat strong {
  color: $color-text-primary;
  font-size: 18px;
}

.course-dashboard {
  display: grid;
  gap: 26px;
  padding: 30px;
  border: 1px solid rgba($color-border, 0.92);
  border-radius: 24px;
  background:
    linear-gradient(135deg, rgba($color-surface, 0.98) 0%, rgba($color-background, 0.94) 100%);
  box-shadow: 0 18px 44px rgba(31, 38, 52, 0.08);
}

.course-dashboard__top,
.course-dashboard__actions,
.course-dashboard__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 14px;
}

.course-dashboard__top {
  justify-content: space-between;
}

.course-dashboard__actions {
  justify-content: flex-end;
}

.course-dashboard__grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(170px, 220px) minmax(260px, 330px);
  gap: 18px;
  align-items: stretch;
}

.course-dashboard__title,
.course-dashboard__metric,
.course-dashboard__teacher {
  min-width: 0;
  border: 1px solid rgba($color-border, 0.88);
  border-radius: 18px;
  background: $color-surface;
}

.course-dashboard__title {
  display: grid;
  gap: 16px;
  padding: 26px;
}

.course-dashboard__title h1 {
  font-size: clamp(30px, 4vw, 50px);
}

.course-dashboard__title > p:not(.eyebrow) {
  display: -webkit-box;
  overflow: hidden;
  color: $color-text-secondary;
  font-size: 16px;
  line-height: 1.8;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

.course-dashboard__metric {
  display: grid;
  align-content: center;
  justify-items: center;
  gap: 10px;
  padding: 24px;
  background:
    radial-gradient(circle at 50% 18%, rgba(255, 255, 255, 0.22) 0%, rgba(255, 255, 255, 0) 32%),
    linear-gradient(135deg, var(--course-theme-primary) 0%, var(--course-theme-accent) 100%);
  color: $color-surface;
  text-align: center;
}

.course-dashboard__metric span {
  font-size: 15px;
  font-weight: 800;
}

.course-dashboard__metric strong {
  font-size: clamp(56px, 7vw, 92px);
  line-height: 0.96;
}

.course-dashboard__teacher {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 22px;
}

.course-dashboard__teacher > div:last-child {
  display: grid;
  gap: 4px;
}

.course-dashboard__teacher span {
  color: $color-text-tertiary;
  font-size: 13px;
}

.course-dashboard__teacher strong {
  color: $color-text-primary;
  font-size: 22px;
}

.course-dashboard__teacher p {
  color: $color-text-secondary;
  font-size: 14px;
}

.course-dashboard__meta {
  padding: 16px 18px;
  border: 1px solid rgba($color-border, 0.8);
  border-radius: 18px;
  background: rgba($color-surface, 0.72);
}

.course-tabs {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 18px;
  margin-top: 22px;
}

.course-tabs--split {
  justify-content: flex-start;
  gap: 10px;
  padding: 12px;
  border: 1px solid rgba($color-border, 0.9);
  border-radius: 20px;
  background: $color-surface;
  box-shadow: 0 14px 36px rgba(25, 31, 45, 0.07);
}

.course-tabs--dashboard {
  justify-content: flex-start;
  gap: 8px;
  padding: 10px;
  border-radius: 18px;
  background:
    linear-gradient(135deg, var(--course-theme-deep) 0%, rgba(28, 34, 48, 0.96) 100%);
  box-shadow: 0 18px 42px rgba(26, 31, 42, 0.16);
}

.course-tab {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 54px;
  padding: 0 12px 12px;
  border: 0;
  background: transparent;
  color: $color-text-secondary;
  font-size: 18px;
  font-weight: 800;
}

.course-tab small {
  color: rgba($color-primary, 0.86);
  font-size: 13px;
}

.course-tab::after {
  content: '';
  position: absolute;
  right: 12px;
  bottom: 0;
  left: 12px;
  height: 3px;
  border-radius: 999px;
  background: transparent;
  transition: background-color 0.18s ease;
}

.course-tab.is-active {
  color: var(--course-theme-primary);
}

.course-tab.is-active::after {
  background: linear-gradient(135deg, var(--course-theme-primary) 0%, var(--course-theme-accent) 100%);
}

.course-tabs--split .course-tab {
  min-height: 46px;
  padding: 0 18px;
  border: 1px solid transparent;
  border-radius: 999px;
  background: rgba($color-background, 0.82);
  color: $color-text-secondary;
  font-size: 15px;
  font-weight: 800;
}

.course-tabs--split .course-tab::after {
  display: none;
}

.course-tabs--split .course-tab small {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  padding: 0 7px;
  border-radius: 999px;
  background: rgba($color-surface, 0.88);
  color: var(--course-theme-primary);
  font-size: 12px;
}

.course-tabs--split .course-tab.is-active {
  border-color: rgba($color-primary, 0.18);
  background: linear-gradient(135deg, var(--course-theme-primary) 0%, var(--course-theme-accent) 100%);
  color: $color-surface;
  box-shadow: 0 10px 24px rgba($color-primary, 0.2);
}

.course-tabs--split .course-tab.is-active small {
  background: rgba($color-surface, 0.18);
  color: $color-surface;
}

.course-tabs--dashboard .course-tab {
  min-height: 48px;
  padding: 0 16px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.72);
  font-size: 15px;
  font-weight: 800;
}

.course-tabs--dashboard .course-tab::after {
  display: none;
}

.course-tabs--dashboard .course-tab small {
  min-width: 22px;
  color: rgba(255, 214, 108, 0.9);
  font-size: 12px;
}

.course-tabs--dashboard .course-tab.is-active {
  background: $color-surface;
  color: var(--course-theme-primary);
}

.course-tabs--dashboard .course-tab.is-active small {
  color: var(--course-theme-accent);
}

.detail-content,
.detail-section {
  display: grid;
  gap: 20px;
}

.detail-content {
  margin-top: 20px;
}

.intro-spotlight {
  display: grid;
  grid-template-columns: minmax(240px, 0.34fr) minmax(0, 1fr);
  gap: 0;
  overflow: hidden;
  align-items: start;
  border-radius: 34px;
  background:
    radial-gradient(circle at 14% 86%, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 26%),
    radial-gradient(circle at 88% 18%, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 22%),
    linear-gradient(135deg, var(--course-theme-deep) 0%, var(--course-theme-primary) 52%, var(--course-theme-secondary) 100%);
  color: $color-surface;
}

.intro-mentor {
  display: grid;
  justify-items: center;
  align-content: start;
  gap: 14px;
  padding: 32px 24px;
  text-align: center;
  background: rgba(23, 18, 37, 0.14);
}

.intro-mentor__portrait {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 138px;
  height: 138px;
  overflow: hidden;
  border: 5px solid rgba(255, 206, 120, 0.86);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
  color: $color-surface;
  font-size: 42px;
  font-weight: 800;
}

.intro-mentor__portrait img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.intro-mentor__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 34px;
  padding: 0 16px;
  border-radius: 999px;
  background: linear-gradient(135deg, #ffd66c 0%, var(--course-theme-accent) 100%);
  color: var(--course-theme-deep);
  font-size: 13px;
  font-weight: 900;
}

.intro-mentor h2 {
  font-size: 28px;
}

.intro-mentor p {
  max-width: 220px;
  color: rgba(255, 255, 255, 0.82);
}

.intro-story {
  position: relative;
  display: grid;
  gap: 20px;
  padding: 38px 40px;
}

.intro-story__quote {
  position: absolute;
  top: 18px;
  left: 20px;
  color: rgba(255, 255, 255, 0.22);
  font-size: 88px;
  line-height: 1;
}

.intro-story h3 {
  position: relative;
  z-index: 1;
  font-size: 34px;
}

.intro-story__content {
  position: relative;
  z-index: 1;
  color: rgba(255, 255, 255, 0.92);
  font-size: 18px;
  line-height: 1.95;
}

:deep(.intro-story__content p),
:deep(.intro-story__content ul),
:deep(.intro-story__content ol),
:deep(.intro-story__content blockquote) {
  margin: 0 0 1em;
}

:deep(.intro-story__content p:last-child),
:deep(.intro-story__content ul:last-child),
:deep(.intro-story__content ol:last-child),
:deep(.intro-story__content blockquote:last-child) {
  margin-bottom: 0;
}

:deep(.intro-story__content h1),
:deep(.intro-story__content h2),
:deep(.intro-story__content h3),
:deep(.intro-story__content h4) {
  margin: 0 0 0.7em;
  color: $color-surface;
  line-height: 1.28;
}

:deep(.intro-story__content a) {
  color: #ffe08a;
  text-decoration: underline;
}

.intro-story .pill {
  border-color: rgba(255, 255, 255, 0.16);
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.88);
}

.intro-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.intro-card,
.service-card,
.teacher-card,
.catalog-card {
  border-radius: 28px;
}

.intro-card {
  display: grid;
  gap: 12px;
  padding: 24px;
}

.intro-card__eyebrow {
  color: rgba($color-primary, 0.8);
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}

.intro-card h3 {
  font-size: 24px;
}

.intro-card p {
  color: $color-text-secondary;
}

.catalog-list {
  display: grid;
  gap: 20px;
}

.catalog-card {
  display: grid;
  gap: 18px;
  padding: 24px;
}

.catalog-card__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
}

.catalog-card__title {
  display: grid;
  gap: 8px;
}

.catalog-card__index {
  color: rgba($color-primary, 0.72);
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}

.catalog-card__title h3 {
  font-size: 26px;
}

.catalog-card__title p,
.catalog-card__intro {
  color: $color-text-secondary;
}

.catalog-card__intro,
.catalog-section__intro {
  line-height: 1.7;
}

:deep(.catalog-card__intro p),
:deep(.catalog-card__intro ul),
:deep(.catalog-card__intro ol),
:deep(.catalog-card__intro blockquote),
:deep(.catalog-section__intro p),
:deep(.catalog-section__intro ul),
:deep(.catalog-section__intro ol),
:deep(.catalog-section__intro blockquote) {
  margin: 0 0 0.75em;
}

:deep(.catalog-card__intro p:last-child),
:deep(.catalog-card__intro ul:last-child),
:deep(.catalog-card__intro ol:last-child),
:deep(.catalog-card__intro blockquote:last-child),
:deep(.catalog-section__intro p:last-child),
:deep(.catalog-section__intro ul:last-child),
:deep(.catalog-section__intro ol:last-child),
:deep(.catalog-section__intro blockquote:last-child) {
  margin-bottom: 0;
}

:deep(.catalog-card__intro h1),
:deep(.catalog-card__intro h2),
:deep(.catalog-card__intro h3),
:deep(.catalog-card__intro h4),
:deep(.catalog-section__intro h1),
:deep(.catalog-section__intro h2),
:deep(.catalog-section__intro h3),
:deep(.catalog-section__intro h4) {
  margin: 0 0 0.6em;
  line-height: 1.3;
}

.catalog-section-list {
  display: grid;
  gap: 12px;
}

.catalog-section {
  display: grid;
  gap: 16px;
  padding: 16px 18px;
  border: 1px solid rgba($color-border, 0.94);
  border-radius: 18px;
  background: rgba($color-surface, 0.72);
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: rgba($color-primary, 0.4);
    background: rgba($color-primary-light, 0.3);
    transform: translateX(2px);
  }
}

.catalog-section__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
}

.catalog-section__header strong {
  display: block;
  font-size: 16px;
}

.catalog-section__header p,
.catalog-section__intro {
  margin-top: 6px;
  color: $color-text-secondary;
  font-size: 14px;
}

.catalog-section__header > span {
  color: $color-primary;
  font-weight: 800;
  white-space: nowrap;
}

.catalog-exam {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 16px;
  border: 1px solid rgba($color-primary, 0.2);
  border-radius: 14px;
  background: rgba($color-primary-light, 0.2);
}

.catalog-exam--section {
  margin-top: -2px;
  background: rgba($color-surface, 0.9);
}

.catalog-exam__content {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 12px;
  min-width: 0;
}

.catalog-exam__label {
  color: $color-primary;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.catalog-exam__content strong {
  color: $color-text-primary;
}

.catalog-exam__status {
  color: $color-primary;
  font-size: 13px;
  font-weight: 700;
}

.catalog-exam__status.is-passed {
  color: $color-success;
}

@media (max-width: 640px) {
  .catalog-exam {
    align-items: flex-start;
    flex-direction: column;
  }
}

.task-point-list {
  display: grid;
  gap: 10px;
}

.task-point-list--chapter {
  padding: 14px;
  border-radius: 18px;
  background: rgba($color-primary-light, 0.22);
}

.task-point-list--section {
  padding-top: 4px;
}

.task-point-item {
  padding: 12px 14px;
  border: 1px solid rgba($color-primary, 0.16);
  border-radius: 14px;
  background: rgba($color-surface, 0.86);
}

.task-point-item strong {
  display: block;
  color: $color-text-primary;
  font-size: 15px;
}

.task-point-item p {
  margin-top: 6px;
  color: $color-text-secondary;
  font-size: 14px;
  line-height: 1.7;
}

.service-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
}

.service-card {
  display: grid;
  gap: 14px;
  padding: 24px;
}

.service-card__index {
  color: rgba($color-primary, 0.72);
  font-size: 32px;
  font-weight: 900;
  line-height: 1;
}

.service-card h3 {
  font-size: 24px;
}

.service-card p {
  color: $color-text-secondary;
  line-height: 1.8;
}

.teacher-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
}

.teacher-card {
  display: grid;
  gap: 18px;
  padding: 24px;
}

.teacher-card__avatar-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 84px;
  height: 84px;
  border-radius: 50%;
  background: rgba($color-primary-light, 0.82);
}

.teacher-card__avatar {
  width: 84px;
  height: 84px;
  border-radius: 50%;
  object-fit: cover;
}

.teacher-card__fallback {
  color: $color-primary;
  font-size: 28px;
  font-weight: 800;
}

.teacher-card__content {
  display: grid;
  gap: 6px;
}

.teacher-card__content h3 {
  font-size: 22px;
}

.teacher-card__content p,
.teacher-card__content span {
  color: $color-text-secondary;
}

@media (max-width: 1100px) {
  .course-summary__body,
  .course-brief,
  .course-dashboard__grid,
  .intro-spotlight,
  .intro-grid,
  .service-grid,
  .teacher-grid {
    grid-template-columns: 1fr;
  }

  .course-summary__actions {
    justify-content: flex-start;
  }

  .course-brief__media {
    grid-template-rows: auto auto;
  }
}

@media (max-width: 768px) {
  .course-stage {
    min-height: 360px;
    padding: 24px 20px 120px;
    border-radius: 28px;
  }

  .course-stage__inner {
    gap: 42px;
  }

  .course-summary {
    margin-top: -78px;
    padding: 18px;
    border-radius: 24px;
  }

  .course-summary__metric {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .course-summary__metric strong {
    font-size: 52px;
  }

  .course-summary__metric span {
    font-size: 18px;
  }

  .course-brief,
  .course-dashboard {
    padding: 20px;
    border-radius: 22px;
  }

  .course-brief__stats {
    grid-template-columns: 1fr;
  }

  .course-brief__cover,
  .course-brief__cover img {
    min-height: 220px;
  }

  .course-dashboard__top,
  .course-dashboard__actions,
  .course-dashboard__teacher {
    align-items: flex-start;
  }

  .course-dashboard__actions {
    justify-content: flex-start;
  }

  .course-tabs {
    justify-content: flex-start;
    gap: 10px;
    overflow-x: auto;
    padding-bottom: 4px;
  }

  .detail-content {
    margin-top: 24px;
  }

  .course-tab {
    min-height: 46px;
    padding: 0 8px 10px;
    font-size: 16px;
    white-space: nowrap;
  }

  .course-tabs--split .course-tab,
  .course-tabs--dashboard .course-tab {
    padding: 0 14px;
    font-size: 14px;
  }

  .intro-story,
  .catalog-card,
  .teacher-card,
  .service-card,
  .intro-card,
  .resource-detail-dialog__panel,
  .resource-card,
  .textbook-card {
    padding: 20px;
  }

  .catalog-card__head,
  .catalog-section__header,
  .resource-detail-dialog__header,
  .resource-detail-dialog__actions {
    flex-direction: column;
    align-items: flex-start;
  }

  .resource-detail-dialog {
    padding: 16px;
  }
}

.resource-grid,
.textbook-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.knowledge-graph-preview {
  margin-top: 20px;
  padding: 40px;
  text-align: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  color: white;
}

.knowledge-graph-preview__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.knowledge-graph-preview__content p {
  margin: 0;
  font-size: 16px;
  opacity: 0.95;
}

.knowledge-graph-preview .btn {
  background: white;
  color: #667eea;
  border: none;
  padding: 12px 32px;
  font-weight: 600;
}

.knowledge-graph-preview .btn:hover {
  background: rgba(255, 255, 255, 0.9);
  transform: translateY(-2px);
}

.resource-card {
  display: flex;
  gap: 16px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.2s;
}

.resource-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.resource-card__icon {
  font-size: 32px;
  flex-shrink: 0;
}

.resource-card__content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.resource-card__content h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.resource-card__content p {
  margin: 0;
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}

.resource-card__meta {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 8px;
}

.resource-card__share {
  align-self: flex-start;
  margin-top: 4px;
  padding: 0;
  border: 0;
  background: transparent;
  color: $color-primary-dark;
  cursor: pointer;
  font: inherit;
  font-size: 13px;
  font-weight: 700;
}

.resource-card__share:hover {
  color: $color-primary;
  text-decoration: underline;
}

.resource-detail-dialog {
  position: fixed;
  inset: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(18, 24, 38, 0.58);
  backdrop-filter: blur(8px);
}

.resource-detail-dialog__panel {
  position: relative;
  width: min(680px, 100%);
  display: grid;
  gap: 24px;
  padding: 28px;
}

.resource-detail-dialog__close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 40px;
  height: 40px;
  border: 0;
  border-radius: 50%;
  background: rgba($color-text-primary, 0.08);
  color: $color-text-primary;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
}

.resource-detail-dialog__header {
  display: flex;
  align-items: flex-start;
  gap: 18px;
}

.resource-detail-dialog__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border-radius: 20px;
  background: rgba($color-primary-light, 0.48);
  font-size: 32px;
  flex-shrink: 0;
}

.resource-detail-dialog__heading {
  display: grid;
  gap: 10px;
}

.resource-detail-dialog__heading h3 {
  font-size: 28px;
}

.resource-detail-dialog__heading p {
  color: $color-text-secondary;
}

.resource-detail-dialog__body {
  display: grid;
  gap: 16px;
}

.resource-detail-dialog__body p {
  color: $color-text-secondary;
  line-height: 1.8;
}

.resource-detail-dialog__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.resource-detail-dialog__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.resource-share-box {
  display: grid;
  gap: 10px;
  padding: 16px;
  border: 1px solid rgba($color-border, 0.92);
  border-radius: 16px;
  background: rgba($color-primary-light, 0.42);

  span {
    color: $color-text-secondary;
    font-size: 13px;
    font-weight: 700;
  }

  a {
    color: $color-primary;
    line-height: 1.5;
    word-break: break-all;
  }

  strong {
    color: $color-text-primary;
  }

  p {
    margin: 0;
  }

  img {
    width: 120px;
    height: 120px;
    border-radius: 12px;
    background: $color-surface;
  }
}

.textbook-card {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  transition: all 0.2s;
}

.textbook-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.textbook-card__cover {
  width: 100%;
  height: 200px;
  background: #f5f5f5;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.textbook-card__cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.textbook-card__fallback {
  font-size: 48px;
}

.textbook-card__content {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 8px;
}

.textbook-card__content h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.textbook-card__content p {
  margin: 0;
  font-size: 14px;
  color: #666;
}

.textbook-card__meta {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 8px;
}

.textbook-card__actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  padding-top: 16px;
  border-top: 1px solid #eeeeee;
}

.textbook-action {
  min-height: 42px;
  padding: 9px 16px;
  border: 1px solid transparent;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  transition: background-color 0.2s, border-color 0.2s, color 0.2s;
}

.textbook-action--preview {
  border-color: #d9d9d9;
  background: #ffffff;
  color: #333333;
}

.textbook-action--preview:hover {
  border-color: #ff6b35;
  color: #e85a2a;
}

.textbook-action--read {
  background: #ff6b35;
  color: #ffffff;
}

.textbook-action--read:hover {
  background: #e85a2a;
}
</style>
